import React from 'react';
import { History as RestoreIcon } from 'lucide-react';
import styles from './MapResetButton.module.scss';

export type MapResetButtonProps = {
    onClick: () => void;
    className?: string;
};

const MapResetButton = ({ onClick, className }: MapResetButtonProps) => {
    return (
        <button type='button' onClick={onClick} className={`${styles.container} ${className || ''}`} aria-label='Reset map view'>
            <RestoreIcon className={styles.icon} />
        </button>
    );
};

export default MapResetButton;
